module.exports = __webpack_public_path__ + "img/exclamation-triangle.2b62167.png";